<template>
  <div>
    <div id="header-box">
      <div class="container flex-center ">
        <div
          class="voice-box pointer flex-center black-8 phone"
          @click="switchLanguage"
        >
          <img
            style="width:20px;height:20px;margin-right: 8px;"
            src="../../assets/images/index/voice.svg"
            alt=""
          />
          {{ selectLang == true ? "Language" : "语言" }}
        </div>
        <a href="/home" class="flex-center" @click="goHome">
          <img
            class="img-responsives"
            src="../../assets/images/logo_main.png"
          />
        </a>
        <div class="list-box flex pc">
          <div class="each-list-box" @click="headerChange(0)">
            <router-link
              class="black-8 link-a"
              to="/home"
              :class="{ 'a-active': headerIndex == 0 }"
              >{{ $t("localization.homeFont") }}</router-link
            >
          </div>
          <div
            class="each-list-box"
            :class="{ 'a-active': headerIndex == 2 }"
            @click="headerChange(2)"
            @mouseover="schemeOver"
            @mouseout="schemeOut"
          >
            <router-link
              class="black-8 link-a"
              :class="{ 'a-active': headerIndex == 2 }"
              to="/logisticsSolution"
              >{{ $t("localization.schemeFont") }}</router-link
            >
            <div
              class="oneself-menu-box oneself-menu-box2 black-7"
              v-show="schemeShow"
              @click.stop=""
            >
              <div
                class="container small-margin flex-center"
                style="height:100%;margin:0 auto"
              >
                <div
                  class="scheme-menu-content flex-center"
                  @click="goEachSolution(3)"
                >
                  <img src="../../assets/images/index/logistics.png" alt="" />
                  <div class="scheme-menu-content-name">
                    {{ $t("localization.logisticsSolveFont") }}
                  </div>
                </div>

                <div
                  class="scheme-menu-content scheme-menu-content2 flex-center"
                  @click="goEachSolution(2)"
                >
                  <img src="../../assets/images/index/plant.png" alt="" />
                  <div class="scheme-menu-content-name">
                    {{ $t("localization.factorySolveFont") }}
                  </div>
                </div>
                <div
                  class="scheme-menu-content flex-center"
                  @click="goEachSolution(1)"
                >
                  <img src="../../assets/images/index/garden.png" alt="" />
                  <div class="scheme-menu-content-name">
                    {{ $t("localization.gardenSolveFont") }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="each-list-box"
            :class="{ 'a-active': headerIndex == 1 }"
            @click="headerChange(1)"
            @mouseover="productOver"
            @mouseout="productOut"
          >
            <router-link
              class="black-8 link-a"
              :class="{ 'a-active': headerIndex == 1 }"
              to="/productCenter"
              >{{ $t("localization.productFont") }}</router-link
            >
            <div class=" oneself-menu-box3 black-7 flex" v-show="productShow"  @click.stop="">
              <div class="container-box flex">
                <div class="container-box-left">
                  <div
                    class="left-tab flex-center"
                    v-for="(item, index) in leftTab"
                    :key="index"
                    :class="{ 'tab-true': leftTabIndex == index }"
                    @click="leftTabClick(index)"
                  >
                    {{ $t(item) }}
                  </div>
                </div>
                <div
                  class="oneself-menu-right container-box-right container-box-right2 flex"
                  v-if="leftTabIndex == 0"
                >
                  <div class="platform-box">
                    <div class="each-platform-box" v-for="item in productData" :key="item.value" @click="platformClick(item.url)">
                      <img
                        :src="item.img"
                        alt=""
                      />
                      <div class="each-platform-details">
                        <div class="platform-details-title">
                          {{ $t(item.title) }}
                        </div>
                        <div class="platform-details-text">
                          {{ $t(item.value) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="oneself-menu-right container-box-right flex"
                  v-if="leftTabIndex == 1"
                >
                  <div class="oneself-menu-right-content-box4">
                    <div
                      class="oneself-menu-right-content-title"
                      style="margin-bottom:30px"
                    >
                      {{ $t("localization.newProductData") }}
                    </div>
                    <div class="oneself-menu-right-content2">
                      <a
                        class="each-oneself-menu-right-content"
                        href="http://cloud.nti56.com/webApplication"
                        target="_blank"
                        >{{ $t("localization.newProductData1") }}</a
                      >
                    </div>
                  </div>
                  <div class="oneself-menu-right-content-box4">
                    <div
                      class="oneself-menu-right-content-title"
                      style="margin-bottom:30px"
                    >
                      {{ $t("localization.newProductData2") }}
                    </div>
                    <div class="oneself-menu-right-content2">
                      <a
                        class="each-oneself-menu-right-content"
                        href="http://cloud.nti56.com/webApplication"
                        target="_blank"
                        >{{ $t("localization.newProductData3") }}</a
                      >
                    </div>
                    <div class="oneself-menu-right-content2">
                      <a
                        class="each-oneself-menu-right-content"
                        href="http://cloud.nti56.com/webApplication"
                        target="_blank"
                        >{{ $t("localization.newProductData4") }}</a
                      >
                    </div>
                  </div>
                  <div class="oneself-menu-right-content-box4">
                    <div
                      class="oneself-menu-right-content-title"
                      style="margin-bottom:30px"
                    >
                      {{ $t("localization.newProductData5") }}
                    </div>
                    <div class="oneself-menu-right-content2">
                      <a
                        class="each-oneself-menu-right-content"
                        href="http://cloud.nti56.com/webApplication"
                        target="_blank"
                        >{{ $t("localization.newProductData6") }}</a
                      >
                    </div>
                    <div class="oneself-menu-right-content2">
                      <a
                        class="each-oneself-menu-right-content"
                        href="http://cloud.nti56.com/webApplication"
                        target="_blank"
                        >{{ $t("localization.newProductData7") }}</a
                      >
                    </div>
                  </div>
                  <div class="oneself-menu-right-content-box4">
                    <div
                      class="oneself-menu-right-content-title"
                      style="margin-bottom:30px"
                    >
                      {{ $t("localization.newProductData25") }}
                    </div>
                    <div class="oneself-menu-right-content2">
                      <a
                        class="each-oneself-menu-right-content"
                        href="http://cloud.nti56.com/webApplication"
                        target="_blank"
                        >{{ $t("localization.newProductData26") }}</a
                      >
                    </div>
                    <div class="oneself-menu-right-content2">
                      <a
                        class="each-oneself-menu-right-content"
                        href="http://cloud.nti56.com/webApplication"
                        target="_blank"
                        >{{ $t("localization.newProductData27") }}</a
                      >
                    </div>
                  </div>
                  <div class="oneself-menu-right-content-box4">
                    <div
                      class="oneself-menu-right-content-title"
                      style="margin-bottom:30px"
                    >
                      {{ $t("localization.newProductData15") }}
                    </div>
                    <div class="oneself-menu-right-content2">
                      <a
                        class="each-oneself-menu-right-content"
                        href="http://cloud.nti56.com/webApplicationDetail"
                        target="_blank"
                        >{{ $t("localization.newProductData16") }}</a
                      >
                    </div>
                    <div class="oneself-menu-right-content2">
                      <a
                        class="each-oneself-menu-right-content"
                        href="http://cloud.nti56.com/webApplicationDetail"
                        target="_blank"
                        >{{ $t("localization.newProductData17") }}</a
                      >
                    </div>
                    <div class="oneself-menu-right-content2">
                      <a
                        class="each-oneself-menu-right-content"
                        href="http://cloud.nti56.com/webApplicationDetail"
                        target="_blank"
                        >{{ $t("localization.newProductData18") }}</a
                      >
                    </div>
                    <div class="oneself-menu-right-content2">
                      <a
                        class="each-oneself-menu-right-content"
                        href="http://cloud.nti56.com/webApplication"
                        target="_blank"
                        >{{ $t("localization.newProductData19") }}</a
                      >
                    </div>
                  </div>
                  <div class="oneself-menu-right-content-box4">
                    <div
                      class="oneself-menu-right-content-title"
                      style="margin-bottom:30px"
                    >
                      {{ $t("localization.newProductData20") }}
                    </div>
                    <div class="oneself-menu-right-content2">
                      <a
                        class="each-oneself-menu-right-content"
                        href="http://cloud.nti56.com/webApplication"
                        target="_blank"
                        >{{ $t("localization.newProductData21") }}</a
                      >
                    </div>
                    <div class="oneself-menu-right-content2">
                      <a
                        class="each-oneself-menu-right-content"
                        href="http://cloud.nti56.com/webApplication"
                        target="_blank"
                        >{{ $t("localization.newProductData22") }}</a
                      >
                    </div>
                    <div class="oneself-menu-right-content2">
                      <a
                        class="each-oneself-menu-right-content"
                        href="http://cloud.nti56.com/webApplication"
                        target="_blank"
                        >{{ $t("localization.newProductData23") }}</a
                      >
                    </div>
                    <div class="oneself-menu-right-content2">
                      <a
                        class="each-oneself-menu-right-content"
                        href="http://cloud.nti56.com/webApplication"
                        target="_blank"
                        >{{ $t("localization.newProductData24") }}</a
                      >
                    </div>
                  </div>
                  <div class="oneself-menu-right-content-box4">
                    <div
                      class="oneself-menu-right-content-title"
                      style="margin-bottom:30px"
                    >
                      {{ $t("localization.newProductData8") }}
                    </div>
                    <div class="oneself-menu-right-content2">
                      <a
                        class="each-oneself-menu-right-content"
                        href="http://cloud.nti56.com/webApplication"
                        target="_blank"
                        >{{ $t("localization.newProductData9") }}</a
                      >
                    </div>
                    <div class="oneself-menu-right-content2">
                      <a
                        class="each-oneself-menu-right-content"
                        href="http://cloud.nti56.com/webApplication"
                        target="_blank"
                        >{{ $t("localization.newProductData10") }}</a
                      >
                    </div>
                    <div class="oneself-menu-right-content2">
                      <a
                        class="each-oneself-menu-right-content"
                        href="http://cloud.nti56.com/webApplication"
                        target="_blank"
                        >{{ $t("localization.newProductData11") }}</a
                      >
                    </div>
                    <div class="oneself-menu-right-content2">
                      <a
                        class="each-oneself-menu-right-content"
                        href="http://cloud.nti56.com/webApplication"
                        target="_blank"
                        >{{ $t("localization.newProductData12") }}</a
                      >
                    </div>
                    <div class="oneself-menu-right-content2">
                      <a
                        class="each-oneself-menu-right-content"
                        href="http://cloud.nti56.com/webApplication"
                        target="_blank"
                        >{{ $t("localization.newProductData13") }}</a
                      >
                    </div>
                    <div class="oneself-menu-right-content2">
                      <a
                        class="each-oneself-menu-right-content"
                        href="http://cloud.nti56.com/webApplication"
                        target="_blank"
                        >{{ $t("localization.newProductData14") }}</a
                      >
                    </div>
                  </div>
                </div>
                <div
                  class="oneself-menu-right container-box-right container-box-right2 flex"
                  v-if="leftTabIndex == 2"
                >
                  <div class="platform-box">
                   <div class=" each-platform-box each-platform-box2"  @click.stop="goAgv">
                    <img src="../../assets/images/index/new-agv.png" alt="">
                    <div class="each-platform-details">
                        <div class="platform-details-title">
                          {{  $t("localization.AGVFont") }}
                        </div>
                        <div class="platform-details-text">
                          {{  $t("localization.newProductData41")}}
                        </div>
                      </div>
                   </div>
                   <div class=" each-platform-box each-platform-box2" @click.stop="goPiler">
                    <img src="../../assets/images/index/new-piler.png" alt="">
                    <div class="each-platform-details">
                        <div class="platform-details-title">
                          {{  $t("localization.stackerFont") }}
                        </div>
                        <div class="platform-details-text">
                          {{  $t("localization.newProductData42")}}
                        </div>
                      </div>
                   </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="each-list-box"
            @click="headerChange(3)"
            @mouseover="caseOver"
            @mouseout="caseOut"
          >
            <a
              class="black-8 link-a pointer"
              :class="{ 'a-active': headerIndex == 3 }"
              @click="goCase"
              >{{ $t("localization.caseFont") }}</a
            >
            <div
              class=" oneself-menu-box black-7"
              v-show="caseShow"
              @click.stop=""
            >
              <div class="container flex">
                <div class="oneself-menu-right">
                  <div class="oneself-menu-right-content-box" style="width:80%">
                    <div class="oneself-menu-right-content-title">
                      {{ $t("localization.all") }}
                    </div>
                    <div
                      class="oneself-menu-right-content flex"
                      style="flex-wrap: wrap;"
                    >
                      <a
                        class="each-oneself-menu-right-content  each-oneself-menu-right-content2"
                        v-for="(item, index) in caseHoverData"
                        :key="index"
                        :class="{ 'facility-true': caseChildrenIndex == index }"
                        @click.stop="caseClick(index, item)"
                        >{{ item.classifyName }}</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="each-list-box"
            @click="headerChange(4)"
            @mouseover="serveOver"
            @mouseout="serveOut"
          >
            <router-link
              class="black-8 link-a"
              :class="{ 'a-active': headerIndex == 4 }"
              to="/serviceSupport"
              >{{ $t("localization.serveFont") }}</router-link
            >
            <div
              class="oneself-menu-box oneself-menu-box2 black-7"
              v-show="serveShow"
              @click.stop=""
            >
              <div
                class="container small-margin flex-center"
                style="height:100%;margin:0 auto"
              >
                <div
                  class="serve-menu-content flex"
                  @click="goServiceSupport(1)"
                >
                  <img
                    class="serve-img serve-img1"
                    src="../../assets/images/service-suppot/popup1.png"
                    alt=""
                  />
                  <div class="scheme-menu-content-name">
                    {{ $t("localization.serviceSupportFont51") }}
                  </div>
                </div>
                <div
                  class="serve-menu-content flex"
                  @click="goServiceSupport(2)"
                >
                  <img
                    class="serve-img serve-img2"
                    src="../../assets/images/service-suppot/popup2.png"
                    alt=""
                  />
                  <div class="scheme-menu-content-name">
                    {{ $t("localization.serviceSupportFont2") }}
                  </div>
                </div>
                <div
                  class="serve-menu-content flex"
                  @click="goServiceSupport(3)"
                >
                  <img
                    class="serve-img serve-img3"
                    src="../../assets/images/service-suppot/popup3.png"
                    alt=""
                  />
                  <div class="scheme-menu-content-name">
                    {{ $t("localization.serviceSupportFont10") }}
                  </div>
                </div>
                <div
                  class="serve-menu-content flex"
                  @click="goServiceSupport(4)"
                >
                  <img
                    class="serve-img serve-img4"
                    src="../../assets/images/service-suppot/popup4.png"
                    alt=""
                  />
                  <div class="scheme-menu-content-name">
                    {{ $t("localization.serviceSupportFont23") }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="each-list-box"
            @mouseover="investorOver"
            @mouseout="investorOut"
            v-if="voiceData == 'zh-CN'"
            @click="headerChange(5)"
          >
            <router-link
              class="black-8 link-a"
              :class="{ 'a-active': headerIndex == 5 }"
              to="/secretaries"
              >{{ $t("localization.investorFont") }}</router-link
            >
            <div
              class="oneself-menu-box oneself-menu-box2 black-7"
              v-show="investorShow"
              @click.stop=""
            >
              <div
                class="container small-margin flex-center"
                style="height:100%;margin:0 auto"
              >
                <!-- <div
                  class="investor-menu-content flex-center"
                  @click="goInvestor(1)"
                >
                  <img
                    src="../../assets/images/investor/stockmarket.png"
                    alt=""
                  />
                  <div class="scheme-menu-content-name">
                    {{ $t("localization.stockmarket") }}
                  </div>
                </div> -->

                <div
                  class="scheme-menu-content flex-center"
                  @click="goInvestor(2)"
                >
                  <img
                    src="../../assets/images/investor/secretaries.png"
                    alt=""
                  />
                  <div class="scheme-menu-content-name">
                    {{ $t("localization.secretaries") }}
                  </div>
                </div>
                <!-- <div
                  class="investor-menu-content flex-center"
                  @click="goInvestor(3)"
                >
                  <img
                    src="../../assets/images/investor/investorNews.png"
                    alt=""
                  />
                  <div class="scheme-menu-content-name">
                    {{ $t("localization.investorNews") }}
                  </div>
                </div> -->
                <a
                  class="scheme-menu-content flex-center black-8 scheme-menu-content2"
                  rel="noopener noreferrer"
                  href="http://www.cninfo.com.cn/new/fulltextSearch?notautosubmit=&keyWord=%E4%BB%8A%E5%A4%A9%E5%9B%BD%E9%99%85"
                  target="_blank"
                >
                  <img src="../../assets/images/investor/notice.png" alt="" />
                  <div class="scheme-menu-content-name">
                    {{ $t("localization.notice") }}
                  </div>
                </a>
                <a
                  class="scheme-menu-content flex-center black-8"
                  rel="noopener noreferrer"
                  href="http://irm.cninfo.com.cn/ircs/company/companyDetail?stockcode=300532&orgId=9900021797"
                  target="_blank"
                >
                  <img src="../../assets/images/investor/interact.png" alt="" />
                  <div class="scheme-menu-content-name">
                    {{ $t("localization.interact") }}
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div
            class="each-list-box"
            @click="headerChange(6)"
            @mouseover="aboutOver"
            @mouseout="aboutOut"
          >
            <router-link
              class="black-8 link-a"
              :class="{ 'a-active': headerIndex == 6 }"
              to="/aboutUs"
              >{{ $t("localization.aboutFont") }}</router-link
            >
            <div
              class=" oneself-menu-box black-7"
              v-show="aboutShow"
              @click.stop=""
            >
              <div class="container flex">
                <div class="oneself-menu-right flex">
                  <div class="oneself-menu-right-content-box">
                    <div class="oneself-menu-right-content-title">
                      {{ $t("localization.aboutFont33") }}
                    </div>
                    <div class="oneself-menu-right-content">
                      <a
                        class="each-oneself-menu-right-content "
                        :class="{ 'facility-true': aboutChildrenIndex == 1 }"
                        @click.stop="aboutClick(1)"
                        >{{ $t("localization.aboutFont14") }}</a
                      >
                      <a
                        class="each-oneself-menu-right-content "
                        :class="{ 'facility-true': aboutChildrenIndex == 2 }"
                        @click.stop="aboutClick(2)"
                        >{{ $t("localization.aboutFont9") }}</a
                      >
                      <a
                        class="each-oneself-menu-right-content "
                        :class="{ 'facility-true': aboutChildrenIndex == 3 }"
                        @click.stop="aboutClick(3)"
                        >{{ $t("localization.aboutFont10") }}</a
                      >
                      <a
                        class="each-oneself-menu-right-content "
                        :class="{ 'facility-true': aboutChildrenIndex == 4 }"
                        v-if="voiceId=='zh'"
                        @click.stop="aboutClick(4)"
                        >{{ $t("localization.aboutFont37") }}</a
                      >
                    </div>
                  </div>
                  <div class="oneself-menu-right-content-box ">
                    <div class="oneself-menu-right-content-title">
                      {{ $t("localization.aboutFont34") }}
                    </div>
                    <div class="oneself-menu-right-content">
                      <a
                        class="each-oneself-menu-right-content "
                        :class="{ 'facility-true': aboutChildrenIndex == 5 }"
                        @click.stop="aboutClick(5)"
                        >{{ $t("localization.aboutFont13") }}</a
                      >
                      <a
                        class="each-oneself-menu-right-content "
                        :class="{ 'facility-true': aboutChildrenIndex == 6 }"
                        @click.stop="aboutClick(6)"
                        >{{ $t("localization.aboutFont12") }}</a
                      >
                      <a
                        class="each-oneself-menu-right-content "
                        :class="{ 'facility-true': aboutChildrenIndex == 7 }"
                        @click.stop="aboutClick(7)"
                        >{{ $t("localization.aboutFont11") }}</a
                      >
                    </div>
                  </div>
                  <div class="oneself-menu-right-content-box">
                    <div class="oneself-menu-right-content-title">
                      {{ $t("localization.aboutFont35") }}
                    </div>
                    <div class="oneself-menu-right-content">
                      <a
                        class="each-oneself-menu-right-content "
                        :class="{ 'facility-true': aboutChildrenIndex == 8 }"
                        @click.stop="aboutClick(8)"
                        >{{ $t("localization.aboutFont15") }}</a
                      >
                      <a
                        class="each-oneself-menu-right-content "
                        :class="{ 'facility-true': aboutChildrenIndex == 9 }"
                        @click.stop="aboutClick(9)"
                        >{{ $t("localization.video") }}</a
                      >
                      <a
                        class="each-oneself-menu-right-content "
                        :class="{ 'facility-true': aboutChildrenIndex == 10 }"
                        @click.stop="aboutClick(10)"
                        >{{ $t("localization.aboutFont42") }}</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="each-list-box"
            v-if="voiceData == 'zh-CN'"
            @click="headerChange(7)"
          >
            <router-link
              class="black-8 link-a"
              :class="{ 'a-active': headerIndex == 7 }"
              to="/joinUs"
              >{{ $t("localization.joinUsFont") }}</router-link
            >
          </div>
        </div>
        <!-- <img
          style="width:auto;height:auto"
          :src="selectLang == true ? imgSrc2 : imgSrc"
          alt=""
          @click="switchLanguage"
          class="pointer voice-img pc"
        /> -->
        <div
          class="voice-box pointer flex-center black-8 pc"
          href="#"
          @click="switchLanguage"
        >
          <img
            class="voice-svg"
            style="width:20px;height:20px;margin-right: 8px"
            src="../../assets/images/index/voice.svg"
          />
          {{ selectLang == true ? "Language" : "语言" }}
        </div>
        <img
          class="img-hamburger  phone"
          @click="tabClick"
          src="../../assets/images/index/line.png"
        />
      </div>
    </div>
    <phone-tab :tabShow="tab" @hidePop="hidePopTrue"></phone-tab>
  </div>
</template>
<script>
import phoneTab from "./header-pop/phone-tab.vue";
import { getClassify } from "@/api/index.js";
export default {
  data() {
    return {
      headerIndex: 0,
      imgSrc: require("../../assets/images/index/zh.png"),
      imgSrc2: require("../../assets/images/index/english.png"),
      // selectLang: localStorage.getItem("DefaultLanguage"),
      selectLang: false,
      language: [
        {
          value: "zh-CN",
          label: "中文简体",
          img: require("../../assets/images/index/china.png")
        },
        {
          value: "en-US",
          label: "English",
          img: require("../../assets/images/index/en.png")
        }
      ],
      productShow: false,
      schemeShow: false,
      tab: false,
      // bgs: {
      //   backgroundColor: ""
      // },
      voiceData: "",
      facilityIndex: null,
      aboutShow: false,
      aboutChildrenIndex: "",
      serveShow: false,
      caseShow: false,
      caseHoverData: [],
      voiceId: "",
      caseChildrenIndex: null,
      investorShow: false, //投资者关系
      leftTab: [
        "localization.newProductData28",
        "localization.newProductData29",
        "localization.newProductData30"
      ],
      leftTabIndex: 0,
      productData: [
        {
          title: "localization.newProductData31",
          value: "localization.newProductData32",
          img: require("../../assets/images/index/industrial-img.png"),
          url:"http://cloud.nti56.com/webApplication"
        },
        {
          title: "localization.newProductData33",
          value: "localization.newProductData34",
          img: require("../../assets/images/index/software-img.png"),
          url:"http://cloud.nti56.com/it/"
        },
        {
          title: "localization.newProductData35",
          value: "localization.newProductData36",
          img: require("../../assets/images/index/control-img.png"),
          url:"https://cloud.nti56.com/iiot/login"
        },
        {
          title: "localization.newProductData37",
          value: "localization.newProductData38",
          img: require("../../assets/images/index/data-img.png"),
          url:"http://cloud.nti56.com/ntibigdata/#/login"
        },
        {
          title: "localization.newProductData39",
          value: "localization.newProductData40",
          img: require("../../assets/images/index/twinborn-img.png"),
          url:"https://cloud.nti56.com/dtts/auth/home"
        }
      ]
    };
  },
  mounted() {
    this.voiceData =
      localStorage.getItem("DefaultLanguage") == null
        ? "zh-CN"
        : localStorage.getItem("DefaultLanguage");
    this.voiceId =
      localStorage.getItem("DefaultLanguage") == "en-US" ? "en" : "zh";
    this.$i18n.locale = this.voiceData;

    if(localStorage.getItem("caseChildren")) {
      this.caseChildrenIndex = localStorage.getItem("caseChildren")
    }
    this.getClassifyData({ classifyType: "0", language: this.voiceId });
    this.selectLang = this.voiceData == "zh-CN" ? false : true;
    this.headerIndex = sessionStorage.getItem("index")
      ? sessionStorage.getItem("index")
      : 0;
    window.addEventListener("setItem", e => {
      if (e.key == "DefaultLanguage") {
        if (e.newValue == "en-US") {
          this.voiceData = "en-US";
          this.voiceId = "en";
        } else {
          this.voiceData = "zh-CN";
          this.voiceId = "zh";
        }
        this.getClassifyData({ classifyType: "0", language: this.voiceId });
      }
      if (e.key == "aboutChildren") {
        this.aboutChildrenIndex = e.newValue;
      }
      if (e.key == "caseChildren") {
        this.caseChildrenIndex = e.newValue;
      }
      if (e.key == "index") {
        this.headerIndex = e.newValue;
      }
    });
  },
  components: {
    phoneTab
  },

  methods: {
    //平台产品点击
    platformClick(url){
      window.open(url)
    },

    leftTabClick(index) {
      this.leftTabIndex = index;
    },

    //获取成功案例分类
    getClassifyData(data) {
      getClassify(data).then(res => {
        if (res.code == 0) {
          if (res.data.length > 0) {
            this.caseHoverData = [];
            res.data[0].children.forEach(item => {
              this.caseHoverData.push(item);
            });
          } else {
            this.caseHoverData = [];
          }
        }
      });
    },
    goHome() {
      this.headerIndex = 0;
      sessionStorage.setItem("index", 0);
    },
    hidePopTrue() {
      this.tab = false;
    },
    goEachSolution(index) {
      this.headerIndex = 2;
      sessionStorage.setItem("index", 2);
      if (index == 1) {
        this.$router.push("/gardenSolution");
      } else if (index == 2) {
        this.$router.push("/plantSolution");
      } else if (index == 3) {
        this.$router.push("/logisticsSolution");
      }
      this.schemeShow = false;
    },
    //服务与支持
    goServiceSupport(index) {
      this.headerIndex = 4;
      sessionStorage.setItem("index", 4);
      this.serveShow = false;
      this.$router.push({
        path: "/serviceSupport"
      });
      setTimeout(() => {
        this.$router.push({
          path: "/serviceSupport",
          query: {
            anchor: index
          }
        });
      }, 300);
    },
    // handleScroll() {
    //   let scrollTop =
    //     window.pageYOffset ||
    //     document.documentElement.scrollTop ||
    //     document.body.scrollTop;
    //   let homeHeight = this.$parent.$children[3].$children[0].$el.offsetHeight;
    //   if (scrollTop > homeHeight) {
    //     this.bgs.backgroundColor = "#fff";
    //   } else {
    //     this.bgs.backgroundColor = "";
    //   }
    // },
    headerChange(index) {
      this.$addStorageEvent("aboutChildren", 1);
      sessionStorage.setItem("aboutIndex", 1);
      this.headerIndex = index;
      this.facilityIndex = null;
      this.aboutChildrenIndex = null;
      this.caseChildrenIndex = null;
      sessionStorage.setItem("index", index);
      if (index == 6) {
        this.aboutChildrenIndex = 1;
      }
    },
    switchLanguage() {
      this.selectLang = !this.selectLang;
      let value = this.selectLang ? "en-US" : "zh-CN";
      localStorage.setItem("DefaultLanguage", value);
      this.$addStorageEvent("DefaultLanguage", value);
      if (value == "zh-CN") {
        this.$i18n.locale = "zh-CN";
        document.title = "深圳市今天国际物流技术股份有限公司";
      } else if (value == "en-US") {
        this.$i18n.locale = "en-US";
        document.title = "New Trend International Logis-tech Co., Ltd.";
      }
    },
    productOver() {
      this.productShow = true;
      // this.bgs.backgroundColor = "#fff";
    },
    productOut() {
      this.productShow = false;
    },
    schemeOver() {
      this.schemeShow = true;
      // this.bgs.backgroundColor = "#fff";
    },
    schemeOut() {
      this.schemeShow = false;
    },
    aboutOver() {
      this.aboutShow = true;
      // this.bgs.backgroundColor = "#fff";
    },
    aboutOut() {
      this.aboutShow = false;
    },

    serveOver() {
      this.serveShow = true;
      // this.bgs.backgroundColor = "#fff";
    },
    serveOut() {
      this.serveShow = false;
    },
    caseOver() {
      this.caseShow = true;
    },
    caseOut() {
      this.caseShow = false;
    },
    //投资者关系鼠标移入移出
    investorOver() {
      this.investorShow = true;
    },
    investorOut() {
      this.investorShow = false;
    },
    tabClick() {
      this.tab = !this.tab;
    },
    goAgv() {
      this.productShow = false;
      this.$router.push("/AGVDetails");
      this.facilityIndex = 0;
      this.headerIndex = 1;
      sessionStorage.setItem("index", 1);
    },
    goPiler() {
      this.productShow = false;
      this.$router.push("/pilerDetails");
      this.facilityIndex = 1;
      this.headerIndex = 1;
      sessionStorage.setItem("index", 1);
    },
    aboutClick(data) {
      this.headerIndex = 6;
      sessionStorage.setItem("index", 6);
      this.aboutChildrenIndex = data;
      this.aboutShow = false;
      this.$addStorageEvent("caseChildren", -1);
      sessionStorage.setItem("aboutIndex", data);
      this.$addStorageEvent("aboutChildren", data);
      if (data == 1) {
        this.$router.push("/aboutUs/chairman");
        
      } else if (data == 2) {
        this.$router.push("/aboutUs/electricity");
       
      } else if (data == 3) {
        this.$router.push("/aboutUs/development");
     
      } else if (data == 4) {
        this.$router.push("/aboutUs/contactUs");
        // this.$router.push("/aboutUs/certification");
       
      } else if (data == 5) {
        this.$router.push("/aboutUs/culture");
      
      } else if (data == 6) {
        this.$router.push("/aboutUs/responsibility");
      } else if (data == 7) {
        this.$router.push("/aboutUs/certification");
      } else if (data == 8) {
        this.$router.push("/aboutUs/journalism");
      }else if (data == 9) {
        this.$router.push("/aboutUs/videoDetails");
      }
      else if (data == 10) {
        this.$router.push("/aboutUs/downloadCenter");
      }
     
    },
    caseClick(index, item) {
      this.headerIndex = 3;
      sessionStorage.setItem("index", 3);
      this.caseChildrenIndex = index;
      this.caseShow = false;
      this.$addStorageEvent("aboutChildren", 0);
      sessionStorage.setItem("aboutIndex", 0);
      this.$addStorageEvent("caseChildren", index);
      this.$router.push({
        path: "/succeedCase/"+item.outLink
      });
    },
    goCase() {
      this.$addStorageEvent("caseChildren", -1);
      setTimeout(() => {
        this.$router.push({
          path: "/succeedCase"
        });
      });
    },
    goInvestor(data) {
      this.headerIndex = 5;
      sessionStorage.setItem("index", 5);
      this.investorShow = false;
      if (data == 1) {
        this.$router.push({
          path: "/stockmarket"
        });
      } else if (data == 2) {
        this.$router.push({
          path: "/secretaries"
        });
      } else if (data == 3) {
        this.$router.push({
          path: "/investorNews"
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.container /deep/ .el-dropdown {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.el-dropdown-menu {
  top: 40px !important;
}
#header-box {
  position: fixed;
  top: 0;
  z-index: 999999;
  width: 100%;
  height: 60px;
  background: #fff;
  -webkit-transition: all 0.2s linear;
  transition: all 0.2s linear;
  .container {
    justify-content: space-between;

    .list-box {
      flex: 1;
      // margin-left: 100px;
      // margin-right: 60px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex: 1;
      .each-list-box {
        font-weight: 600;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 60px;
        min-width: 40px;
        white-space: nowrap;
        .link-a {
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0px 10px;
        }
        .link-a:hover {
          border-bottom: 3px solid #c7000a;
        }
        .a-active {
          border-bottom: 3px solid #c7000a;
          color: #c7000a;
        }
      }
    }
  }
}
.phone-box {
  width: 100%;
  height: 100%;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.img-hamburger {
  width: 32px;
  height: 32px;
  margin-right: 10px;
  cursor: pointer;
}
.facility-true {
  color: #c7000a !important;
}

.container-box {
  width: 100%;
  .container-box-left {
    width: 16.6%;
    max-width: 320px;
    min-width: 160px;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    background-color: #fafafa;
    .left-tab {
      width: 100%;
      height: 80px;
      color: rgba(0, 0, 0, 0.8);
      font-family: "small-body";
      cursor: pointer;
    }
    .tab-true {
      color: #c7000a;
    }
  }
  .container-box-right {
    flex: 1;
    flex-wrap: wrap;
    justify-content: flex-start;
    .each-oneself-menu-right-content {
      word-break: break-all !important;
      white-space: normal !important;
    }
    .platform-box {
      width: 95%;
      height:  90%;
      display: flex;
      margin: 2.5% 5%;
      flex-wrap: wrap;
      .each-platform-box {
        width: 30%;
        height: 40%;
        background: #ffffff
          linear-gradient(180deg, #f3f5f8 0%, rgba(243, 245, 248, 0.06) 69%);
        box-shadow: 0px 10px 30px 0px rgba(142, 155, 171, 0.25);
        border-radius: 4px;
        border: 2px solid #fff;
        margin-right: 3%;
        display: flex;
        align-items: center;
        cursor: pointer;
        img {
          width: 20.4%;
          height: auto;
          margin-left: 18px;
        }
        .each-platform-details {
          width: 68.8%;
          padding-left: 10px;
          padding-right: 10px;
          height: 100%;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          align-content: center;
          div {
            flex-shrink: 0;
          }
          .platform-details-title {
            width: 100%;
            font-family: "small-body";
            word-break: break-all !important;
            white-space: normal !important;
            color: rgba(0, 0, 0, 0.7);
          }
          .platform-details-text {
            width: 100%;
            max-height: 80%;
            color: rgba(0, 0, 0, 0.5);
            word-break: break-all !important;
            white-space: normal !important;
            font-weight: 400;
            margin-top: 4px;
            overflow: hidden;
          }
        
        }
        .each-platform-details:hover {
          .platform-details-text {
            color: #c7000a;
          }
          .platform-details-title {
            color: #c7000a;
          }
         

        }
      }
      .each-platform-box2 {
        width: 45%;
        height: 30%;
        img {
          width: 20.4%;
          height: auto;
          margin-left: 24px;
        }
        .each-platform-details { 
            padding-left: 24px;
          }
      }
    }
  }
  .container-box-right2 {
    margin-top: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/header.vue